import { render, staticRenderFns } from "./appHead.vue?vue&type=template&id=22e6db8b&scoped=true&"
import script from "./appHead.vue?vue&type=script&lang=js&"
export * from "./appHead.vue?vue&type=script&lang=js&"
import style0 from "./appHead.vue?vue&type=style&index=0&id=22e6db8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6db8b",
  null
  
)

export default component.exports